import styled from 'styled-components';
import { GeneralTitleDefaultBox } from './general-title.default.box';

export const GeneralTitleWsopBox = styled(GeneralTitleDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndAbove } {
        min-width: 40rem;
    }
`;